import { render, staticRenderFns } from "./LeadTitleInfo.vue?vue&type=template&id=2f1a4830&scoped=true"
import script from "./LeadTitleInfo.vue?vue&type=script&lang=js"
export * from "./LeadTitleInfo.vue?vue&type=script&lang=js"
import style0 from "./LeadTitleInfo.vue?vue&type=style&index=0&id=2f1a4830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a4830",
  null
  
)

export default component.exports